/**
 * Navigation helper singleton, populated by `NavigationBinder` in App.js.
 * Lets non-React code (sagas, services) call `history.navigate(path)` and
 * read `history.location` (and `history.previousLocation`) without holding a
 * React Router context.
 *
 * Defaults to safe no-op `navigate`, an empty `location`, and `null` previous
 * location; the binder overrides them on mount and updates `previousLocation`
 * on every navigation. The defaults keep tests that don't render an app tree
 * from blowing up when production code calls `history.navigate(...)`.
 */
export const history = {
    navigate: () => undefined,
    location: { pathname: '/', search: '', hash: '', state: null, key: 'default' },
    previousLocation: null
}

export default history
